export const EstadoIndependiente = {
    pendiente: "PENDIENTE",
    invalido: "INVALIDO",
    rechazado: "RECHAZADO",
    aprobado: "APROBADO",
    preregistro: "EN PRE-REGISTRO",
    procesando: "PROCESANDO AFILIACION"
};

export const EstadosIndependiente = [
    EstadoIndependiente.pendiente,
    EstadoIndependiente.invalido,
    EstadoIndependiente.rechazado,
    EstadoIndependiente.aprobado,
    EstadoIndependiente.preregistro,
    EstadoIndependiente.procesando
];


// WEBPACK FOOTER //
// ./src/co/sura/dominio/reportes/modelo/EstadosIndependiente.ts